module.exports = __webpack_public_path__ + "img/Sitpresta.59fb87bc.png";